import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'en' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2NDEyMzMzMTgyOCwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTAyNzYzIn0.yfUbx_312gbGY_tLS--sHnMSV9CHdGcawh1C3A4zmvSOQe3w7WZKUEtqbxO4mPokCtuooVyop1B4vKNWU0srDw`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
